// extracted by mini-css-extract-plugin
module.exports = {"titleandglance":"Stats_titleandglance__3oLDT","cards":"Stats_cards__1Q0s1"};